import { render, staticRenderFns } from "./indexDateli.vue?vue&type=template&id=6fe3524c&scoped=true"
import script from "./indexDateli.vue?vue&type=script&lang=js"
export * from "./indexDateli.vue?vue&type=script&lang=js"
import style0 from "./indexDateli.vue?vue&type=style&index=0&id=6fe3524c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fe3524c",
  null
  
)

export default component.exports